
export const contactData = [
  {
    type: "phone",
    icon: "feather icon-phone-call",
    title: "Phone Number",
    link: "https://api.whatsapp.com/send?phone=97143426666",
    text: "+(971) 4342-6666",
  },
  {
    type: "email",
    icon: "feather icon-mail",
    title: "Email Address",
    link: "mailto:info@ess.ae",
    text: "info@ess.ae",
  },
  {
    type: "location",
    icon: "feather icon-map-pin",
    title: "Location",
    link: "https://www.bing.com/maps?osid=21a1c7fd-00a2-4e17-a924-6c3942c0bcdb&cp=25.248209~55.302397&lvl=17&pi=0&v=2&sV=2&form=S00027",
    text: "Next to Karama Post Office,Dubai",
  },
  {
    type: "hours",
    icon: "feather icon-clock",
    title: "Opening Hours",
    link: "#;",
    text: `Monday - Thursday 7:00 AM -10:00 PM `,
  },
];
